export const PRODUCTS_SEARCH_REDUCER_NAME = 'productsSearch'
